import { __ } from '@wordpress/i18n';

const FieldHeader = () => {
    return (
        <div className="wds-fieldbox-header">
            <span className="wds-fieldbox-header__title">{ __( 'Delivery Details', 'jckwds' ) }</span>
        </div>
    );
};

export default FieldHeader;